module.exports = __webpack_public_path__ + "static/img/COC2021-29.5c8b0d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-29.jpg
// module id = AA1U
// module chunks = 0